import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'iposcen-ipos-help-creating-user-account',
  templateUrl: './ipos-help-creating-user-account.component.html',
  styleUrls: ['./ipos-help-creating-user-account.component.scss']
})
export class IposHelpCreatingUserAccountComponent implements OnInit {
  @ViewChild('userAccTop') userAccount: ElementRef;
  constructor() { }

  ngOnInit(): void {

    setTimeout(() => {
      this.userAccount.nativeElement.scrollIntoView();
    }, 0);

  }
}
